import { Modal, ModalProps, Stack, Typography, IconButton, Divider, SxProps, Theme, ClickAwayListener } from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useTheme } from "../../Theme/Theme";

export const WcClickAwayListener = ClickAwayListener;
type WcModalProps = ModalProps & {
  modalTitle: string;
  closeHandler: (event?: any, reason?: string) => void;
  disableEscapeKey?: boolean;
  sx?: SxProps<Theme>;
  minWidth?: number | string;
  disableClickOutside?: boolean;
};

export const WcModal = ({
  modalTitle,
  closeHandler,
  disableEscapeKey,
  children,
  sx,
  minWidth,
  disableClickOutside,
  ...props
}: WcModalProps) => {
  const theme = useTheme();
  const handleClose = (event: any, reason: string) => {
    closeHandler(event, reason);
  };

  const handleClosePressed = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    closeHandler();
  };
  return (
    <Modal
      // open={props.open}
      disableEscapeKeyDown={disableEscapeKey}
      onClose={disableClickOutside ? undefined : handleClose}
      {...props}
    >
      <Stack
        id="WcModal"
        sx={{
          position: "absolute",
          top: "40px",
          left: "50%",
          transform: "translate(-50%, 0)",
          //@ts-ignore
          bgcolor: theme.appPalette.neutral[100],
          boxShadow: 24,
          borderRadius: 4,
          padding: 8,
        }}
        onClick={(event) => event.stopPropagation()}
        borderRadius={1}
      >
        <Stack width={"100%"} direction="row" justifyContent={"space-between"} padding={2}>
          <Typography id="modal-modal-title" variant="h6" component="h4">
            {modalTitle}
          </Typography>

          <Stack>
            <IconButton
              onClick={(event) => handleClosePressed(event)}
              sx={{
                display: "flex",
                width: "19px",
                height: "19px",
              }}
            >
              <CloseIcon sx={{ color: "action.active", fontSize: 18.67 }} />
            </IconButton>
          </Stack>
        </Stack>

        <Divider />
        <Stack id="CustomModalInnerStack" width="100%" sx={[...(Array.isArray(sx) ? sx : [sx])]} minWidth={minWidth ? minWidth : 0}>
          {children}
        </Stack>
      </Stack>
    </Modal>
  );
};

export default WcModal;
